import Detail from './Detail'
import StatusDetail from './StatusDetail'

export default Detail
export { StatusDetail }
